const SYSTEM_API = {
	GET_SYSTEMS: '/system/list',
	GET_SYSTEM_BY_GROUP_ID: '/system/byGroupId'
};

export default SYSTEM_API;
